import { render } from "./TreasurePlateIntro.vue?vue&type=template&id=7ad66076&scoped=true"
import script from "./TreasurePlateIntro.vue?vue&type=script&lang=js"
export * from "./TreasurePlateIntro.vue?vue&type=script&lang=js"

import "./TreasurePlateIntro.vue?vue&type=style&index=0&id=7ad66076&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad66076"]])

export default __exports__